/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { shared_FlexibleDate } from './shared_FlexibleDate';
export type allocations_CreateAllocationRequest = {
    /**
     * AgeTypeCode defines the age type (BABY or CHILD) (required)
     */
    age_type_code: allocations_CreateAllocationRequest.age_type_code;
    /**
     * ChildID references the child for this allocation (required)
     */
    child_id: string;
    /**
     * ContractID references the contract for this allocation (required)
     */
    contract_id: string;
    friday_services?: Array<string>;
    /**
     * FromDate when the allocation begins (required)
     */
    from_date: shared_FlexibleDate;
    /**
     * GroupID references the group for this allocation (required)
     */
    group_id: string;
    /**
     * Weekday services (at least one weekday must have non-empty services)
     */
    monday_services?: Array<string>;
    saturday_services?: Array<string>;
    sunday_services?: Array<string>;
    thursday_services?: Array<string>;
    /**
     * ToDate when the allocation ends (required)
     */
    to_date: shared_FlexibleDate;
    tuesday_services?: Array<string>;
    wednesday_services?: Array<string>;
};
export namespace allocations_CreateAllocationRequest {
    /**
     * AgeTypeCode defines the age type (BABY or CHILD) (required)
     */
    export enum age_type_code {
        BABY = 'BABY',
        CHILD = 'CHILD',
    }
}

